import "core-js/modules/esnext.global-this.js";
export var crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;